export default {
  namespaced: true,
  state: {
    reviewModal: {
      show: false,
    },
    thanksExpertModal: {
      show: false,
      item: {},
    },
    thanksCovestoModal: {
      show: false,
    },
  },
  mutations: {
    toggleReviewModal(state, obj) {
      state.reviewModal.show = obj.show ? obj.show : false;
    },
    toggleThanksExpertModal(state, obj) {
      state.thanksExpertModal.show = obj.show ? obj.show : false;
      state.thanksExpertModal.item = obj.item ? obj.item : "";
    },
    toggleThanksCovestoModal(state, obj) {
      state.thanksCovestoModal.show = obj.show ? obj.show : false;
    },
  },
};
